import { SidebarItemsType } from "../../types/sidebar";
import SidebarNavListItem from "./SidebarNavListItem";
import SidebarNavList from "./SidebarNavList";

interface ReduceChildRoutesProps {
  depth: number;
  page: SidebarItemsType;
  items: JSX.Element[];
  currentRoute: string;
  onToggle: (href: string) => void;
  activeHref: string | null;
}

const reduceChildRoutes = (props: ReduceChildRoutesProps) => {
  const { items, page, depth, currentRoute, onToggle, activeHref } = props;

  // Check if the current route matches the page's href to set the initial state of open
  const isOpen = page.href === activeHref;

  if (page.children) {
    items.push(
      <SidebarNavListItem
        depth={depth}
        icon={page.icon}
        key={page.title}
        badge={page.badge}
        open={isOpen} // Ensure open state is passed correctly
        title={page.title}
        href={page.href}
        onToggle={onToggle} // Pass onToggle down to handle click
      >
        <SidebarNavList depth={depth + 1} pages={page.children} />
      </SidebarNavListItem>
    );
  } else {
    items.push(
      <SidebarNavListItem
        depth={depth}
        href={page.href}
        icon={page.icon}
        key={page.title}
        badge={page.badge}
        title={page.title}
        onToggle={onToggle} // Pass onToggle here too
      />
    );
  }

  return items;
};

export default reduceChildRoutes;
